<template>
  <div class="shopping" style="background-color: #f1f1f1;">
    <navtab class="navTab"></navtab>
    <div class="top" v-if="isDetail==1||isDetail==6">
      <div class="topleft">
        <div class="headImg">
          <img :src="headUrl != '' && headUrl != null ?headUrl:localimgUrl" alt />
        </div>
        <p
          class="perName"
          v-show="nickName"
          v-text="nickName!=undefined && nickName!=null?nickName:localname"
        ></p>
        <p
          class="phone"
          v-show="user.phone"
          v-text="'手机号：'+ user.phone !='' && user.phone !=null?user.phone:localuserphone"
        ></p>
        <ul class="tabStatus">
          <li class="tabLi">
            <p class="num" v-text="orderNum[0]">1</p>
            <p class="tabWord">待支付</p>
          </li>
          <li class="tabLi">
            <p class="num" v-text="orderNum[1]">12</p>
            <p class="tabWord">待收货</p>
          </li>
          <li class="tabLi">
            <p class="num" v-text="orderNum[2]">15</p>
            <p class="tabWord">待评价</p>
          </li>
          <li class="tabLi">
            <p class="num" v-text="orderNum[3]">10</p>
            <p class="tabWord">退货</p>
          </li>
        </ul>
        <div class="shopCar" @click="seeShopCar()">
          <p class="el-icon-goods carIcon"></p>
          <p class="shopWord">购物车</p>
        </div>
      </div>
      <div class="lunbo">
        <div class="block">
          <!-- <el-carousel height="420px" :interval="23000000" indicator-position="none">
            <el-carousel-item v-for="(item,index) in lunobo" :key="index">
              <img :src="item.imgurl" alt />
            </el-carousel-item>
          </el-carousel>-->
          <template>
            <el-carousel type="card" height="420px" :interval="2300" indicator-position="none">
              <el-carousel-item
                v-for="(item,index) in lunobo"
                :key="index"
                @click="seeLunboDetail(index)"
              >
                <img :src="item.imgurl" alt />
              </el-carousel-item>
            </el-carousel>
          </template>
        </div>
      </div>
    </div>
    <div class="inputPart" v-if="isDetail==1">
      <div class="inputDiv">
        <el-input placeholder="请输入内容" v-model="keyword" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="isDetail=6">搜索</el-button>
        </el-input>
      </div>
    </div>
    <div class="newThing" v-if="isDetail==1">
      <div class="newLogo">
        <img src="../assets/new.png" alt />
      </div>
      <!-- <ul class="newUl">
        <li v-for="(item,index) in hots" :key="index" :index="index" @click="seeDeatil(index)">
          <img :src="item.imgurl.split(',')[0]" alt>
        </li>
      </ul>-->
      <!-- <h1>货拉拉</h1> -->
      <!-- Swiper -->
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item,index) in hots"
            :key="index"
            :index="index"
            @click="seeDeatil(index)"
          >
            <img :src="item.imgurl.split(',')[0]" alt id="swiperImg" />
          </div>
        </div>
        <div class="swiper-button-next showArrow"></div>
        <div class="swiper-button-prev showArrow"></div>
      </div>
      <!-- <div class="perBoss">
        <div class="el-icon-arrow-left perArrowLeft"></div>
        <ul class="perUl">
          <li v-for="(item,index) in hots" :key="index" :index="index" @click="seeDeatil(index)">
            <img :src="item.imgurl.split(',')[0]" alt/>
          </li>
        </ul>
        <div class="el-icon-arrow-right perArrowRight"></div>
      </div> -->
    </div>
    <div class="hotPart" v-if="isDetail==1">
      <el-tabs v-model="GoodsClassifyIndex" @tab-click="handleClick">
        <el-tab-pane
          v-for="(item,index) in GoodsClassify"
          :key="index"
          :label="item.name"
          :name="'tab-'+index"
        >
          <ul class="hotUl">
            <li
              v-for="(todo,num) in item.list"
              :key="num"
              :index="num"
              :style="{height:liHeight+'px'}"
              @click="seeDeatilOne(index,num)"
            >
              <div class="imgParDiv" :style="{height:heightScOne+'px'}">
                <img :src="todo.imgurl.split(',')[0]" alt />
              </div>
              <!-- v-text="'¥ '+(todo.money==null||todo.money=='null'?0:todo.money)" -->
              <p class="pPrice" v-text="'¥ '+todo.money">￥302.50</p>
              <p class="pTitle" v-text="todo.name">常开式电磁阀</p>
            </li>
          </ul>
        </el-tab-pane>
        <!-- <el-tab-pane label="低功率电路模块" name="tab-1">
          <ul class="hotUl" >
            <li>
              <img src="../assets/3.png" alt>
              <p class="pTitle">常开式电磁阀</p>
              <p class="pPrice">￥302.50</p>
            </li>
            <li>
              <img src="../assets/2.png" alt>
              <p class="pTitle">常开式电磁阀</p>
              <p class="pPrice">￥302.50</p>
            </li>
            <li>
              <img src="../assets/1.png" alt>
              <p class="pTitle">常开式电磁阀</p>
              <p class="pPrice">￥302.50</p>
            </li>
            <li>
              <img src="../assets/4.png" alt>
              <p class="pTitle">常开式电磁阀</p>
              <p class="pPrice">￥302.50</p>
            </li>
            <li>
              <img src="../assets/3.png" alt>
              <p class="pTitle">常开式电磁阀</p>
              <p class="pPrice">￥302.50</p>
            </li>
            <li>
              <img src="../assets/3.png" alt>
              <p class="pTitle">常开式电磁阀</p>
              <p class="pPrice">￥302.50</p>
            </li>
            <li id="nouseLi">
              <img src="../assets/3.png" alt>
              <p class="pTitle">常开式电磁阀</p>
              <p class="pPrice">￥302.50</p>
            </li>
            <li id="nouseLi">
              <img src="../assets/3.png" alt>
              <p class="pTitle">常开式电磁阀</p>
              <p class="pPrice">￥302.50</p>
            </li>
            <li id="nouseLi">
              <img src="../assets/3.png" alt>
              <p class="pTitle">常开式电磁阀</p>
              <p class="pPrice">￥302.50</p>
            </li>
            <li id="nouseLi">
              <img src="../assets/3.png" alt>
              <p class="pTitle">常开式电磁阀</p>
              <p class="pPrice">￥302.50</p>
            </li>
          </ul>
        </el-tab-pane>-->
      </el-tabs>
    </div>
    <!-- @click="seeDeatil(index)" -->
    <div class="thingDetailLeft" v-if="isDetail==2">
      <p class="tellP">热销商品推荐</p>
      <p class="el-icon-arrow-up newtopArrow" @click="addScroll()"></p>
      <ul id="sortHort"  :style="{height:ulH+'px'}">
        <li
          v-for="(items,index) in hots"
          :key="index"
          :index="index"
          :style="{height:newBosslih+'px'}"
          @click="seeSortDetail(index)"
        >
          <!-- :style="{height:newLiH+'px'}" -->
          <div class="hotTop">
            <!-- <div class="sortNum">{{index+1}}</div> -->
            <div class="hotImgDiv" :style="{height:newLiH+'px'}">
              <img :src="items.imgurl.split(',')[0]" alt />
            </div>
          </div>
          <p class="hotMoney">￥{{items.money}}</p>
          <p class="hotName">{{items.name}}</p>
        </li>
      </ul>
      <p class="el-icon-arrow-down newbottomArrow" @click="reduceScroll()"></p>
    </div>
    <div class="thingDetail" v-if="isDetail==2">
      <div class="back el-icon-arrow-left" @click="back()">返回</div>
      <div class="detailPart">
        <div class="detailImg">
          <template class="tempClass">
            <el-carousel indicator-position="none" :interval="2000" :autoplay="true">
              <el-carousel-item v-for="item in endOrder.imgurl.split(',')" :key="item">
                <div class="imgParNewDiv">
                  <img :src="item" alt />
                </div>
              </el-carousel-item>
            </el-carousel>
          </template>
          <!-- <img :src="endOrder.imgurl.split(',')[0]" alt /> -->
        </div>
        <div class="rigDesc">
          <div class="cpPart">
            <p class="cpName" v-text="endOrder.name">电磁阀水阀220V常闭开关阀气12v控制阀</p>
            <p class="cpPrice" v-text="'¥'+endOrder.money">￥302.50</p>
          </div>
          <ul class="cpStatus">
            <li>
              <p class="num" v-text="endOrder.count"></p>
              <p class="statusDesc">已售出</p>
            </li>
            <li>
              <p class="num" v-text="commentList.length">23</p>
              <p class="statusDesc">评论</p>
            </li>
            <li>
              <p class="num" v-text="endOrder.stock">232</p>
              <p class="statusDesc">库存</p>
            </li>
          </ul>
          <div class="carNumPart">
            <p class="sopNum">数量</p>
            <el-input-number
              class="carInput"
              v-model="num"
              @change="changeStock"
              :min="1"
              :max="10"
              label="描述文字"
            ></el-input-number>
          </div>
          <div class="typeList" v-if="typeList.length>0">
            <div class="typeList_title">类别</div>
            <div class="type_list">
              <div
                class="type_one"
                v-for="(item,index) in typeList"
                :key="index"
                v-text="item.name"
                :class="typeIndex==index?'active':''"
                @click="chooseType(index)"
              ></div>
            </div>
          </div>
          <ul class="operatePart">
            <li class="save" @click="collect">{{endOrder.collectType==1?'已收藏':'收藏'}}</li>
            <li class="shopNow" @click="endOrderBuy(1)">立即购买</li>
            <li class="addCar el-icon-goods" @click="endOrderBuy(0)">加入购物车</li>
          </ul>
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClickdetail">
        <el-tab-pane label="商品详情" name="first">
          <div class="sxDiv">
            <p class="sxTitle">产品参数</p>
            <ul class="sxUl">
              <li v-for="(item,index) in sxList" :key="index">
                <span class="borderSpan">{{index+1}}</span>
                <span class="lefSpan">{{item.formatName}}</span>
                <span class="rigSpan">{{item.formatContent}}</span>
              </li>
            </ul>
          </div>
          <div class="com_detail" v-html="endOrder.details"></div>
        </el-tab-pane>
        <el-tab-pane :label="'评论('+commentList.length+')'" name="second">
          <div class="noDataDiv" v-show="commentList.length==0">
            <img src="../assets/noData.png" alt />
          </div>
          <p class="noDataP" v-show="commentList.length==0">暂无评论信息，快来抢沙发！</p>
          <ul class="commentUl">
            <li v-for="(item,index) in commentList" :key="index">
              <div class="commentLef">
                <div class="commentHeadImg">
                  <img
                    :src="item.userInfoEntity.headUrl==null?normalMan:item.userInfoEntity.headUrl"
                    alt
                  />
                </div>
                <p class="commentName" v-text="item.userName"></p>
                <p class="commentTime" v-text="item.modifytime">2019-01-22</p>
              </div>
              <p class="content" v-text="item.content">很好用，下次还在这里买！</p>
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-if="isDetail==3" class="shopCarDetail">
      <div class="topPart">
        <p class="backSee el-icon-arrow-left" @click="back()">返回</p>
        <p class="shopTitle">购物车（{{shopcartList.length}}）</p>
      </div>
      <!-- <div class="allInput">
        <input type="checkbox" name id>
        <p>全选</p>
      </div>-->
      <ul class="gjTab">
        <li class="baby">宝贝</li>
        <li>单价</li>
        <li>数量</li>
        <li>金额</li>
        <li class="operateLi">操作</li>
      </ul>
      <ul class="spUl">
        <li v-for="(item,index) in shopcartList" :key="index" :index="index">
          <div class="spDesc">
            <div class="imgDIv">
              <img :src="item.goodsEntity.imgurl.split(',')[0]" alt />
            </div>
            <div class="spName">{{item.goodsEntity.name}}</div>
            <input
              type="checkbox"
              :checked="item.choose"
              name
              id
              class="oneCheck"
              @click="chooseOne(index)"
            />
          </div>
          <div class="priceOne" v-text="'¥'+item.price">￥230.20</div>
          <div class="inputDiv">
            <el-input-number
              v-model="item.size"
              @change="handleChangecar(item.size,index)"
              :min="1"
              :max="10000"
              label="描述文字"
            ></el-input-number>
          </div>
          <div class="money" v-text="'¥'+item.money">￥460.40</div>
          <div class="operateOne">
            <div
              class="toSave"
              v-text="item.goodsEntity.collectType==1?'取消收藏':'移入收藏夹'"
              @click="collectShopcartOne(index)"
            >移入收藏夹</div>
            <div class="toDelete" @click="deleteShopCart(index)">删除</div>
          </div>
        </li>
        <div class="noDataDiv" v-show="shopcartList.length==0">
          <img src="../assets/noData.png" alt />
        </div>
        <p class="noDataP" v-show="shopcartList.length==0">客官别急，请先添加商品！</p>
        <!-- <li v-show="shopcartList.length==0">
          <p id="tis">客官别急，请先添加商品！</p>
        </li>-->
        <!-- <li>
          <div class="spDesc">
            <div class="imgDIv">
              <img src="../assets/1.png" alt>
            </div>
            <div class="spName">常开式电磁阀</div>
            <input type="checkbox" name id class="oneCheck">
          </div>
          <div class="priceOne">￥230.20</div>
          <div class="inputDiv">
            <el-input-number
              v-model="num2"
              @change="handleChangecar"
              :min="1"
              :max="10"
              label="描述文字"
            ></el-input-number>
          </div>
          <div class="money">￥460.40</div>
          <div class="operateOne">
            <div class="toSave">移入收藏夹</div>
            <div class="toDelete">删除</div>
          </div>
        </li>-->
      </ul>
      <div class="fixedDiv">
        <div class="fixedLef" @click="chooseAllCart">
          <input type="checkbox" :checked="chooseAll" name id />
          <p>全选</p>
        </div>
        <div class="fixedRig">
          <p class="checkedNum">
            已选
            <span id="newclass">{{numAll}}</span>件商品
          </p>
          <p class="totalPrice">
            总计
            <span id="newclass">￥{{moneyAll}}</span>
          </p>
          <div class="giveBtn" @click="goPay">结算</div>
        </div>
      </div>
    </div>
    <div class="payMoney" v-if="isDetail==4">
      <div class="backDiv el-icon-arrow-left" @click="toShopCar()">返回</div>
      <div class="newDiv">
        <p class="choooseNewAddress">选择地址</p>
        <p class="addGetAddress" @click="backToAddress()">添加收货地址</p>
      </div>
      <ul class="addressUl" v-if="isDetail==4">
        <!-- <h2 v-show="addressList.length==0">请先返回添加收货地址再确认订单</h2> -->
        <div class="noDataDiv" id="noDataDiv" v-show="addressList.length==0">
          <img src="../assets/noData.png" alt />
        </div>
        <p class="noDataP" v-show="addressList.length==0">小主请记得要先添加收货地址哦!</p>
        <li
          class="addressLi"
          title="点击设为默认地址"
          v-for="(item,index) in addressList"
          :key="index"
          :value="index"
          @click="chooseAddress(index)"
        >
          <div>
            <div class="nameP">
              <p class="addressName" v-text="item.name">徐毛东</p>
              <p class="isDefault" v-if="item.type==1">默认</p>
            </div>
            <p
              class="addressP"
              :title="item.address+item.detailed"
            >地址：{{item.address+item.detailed}}</p>
            <p class="addressPhone">手机号：+{{item.phone}}</p>
            <p class="AddressEmail">邮编：{{item.postal}}</p>
          </div>
        </li>
      </ul>
      <p class="yesInfo">确认商品信息</p>
      <ul class="yesTab">
        <li class="yesTabBaby">宝贝</li>
        <li>单价</li>
        <li>数量</li>
        <li>金额</li>
      </ul>
      <ul class="yesSpUl">
        <li class="yesLi" v-for="(item,index) in order" :key="index">
          <div class="yesLiBaby">
            <div class="babyImg">
              <div class="newA">
                <img :src="item.goodsEntity.imgurl.split(',')[0]" alt />
              </div>
            </div>
            <p class="babyName" v-text="item.goodsEntity.name">常开式电磁阀</p>
          </div>
          <div class="babyPrice" v-text="'¥'+item.price">￥230.20</div>
          <div class="babyNum" v-text="item.size">1</div>
          <div class="BabyAllPrice" v-text="'¥'+item.price*item.size">￥460.40</div>
        </li>
      </ul>
      <template v-for="(item,index) in addressList">
        <div class="orderDiv" :key="index" :value="index" v-if="item.type==1">
          <div>
            <p>
              <span class="spanEle">实付金额：</span>
              <span class="realMoney">￥{{total}}</span>
            </p>
            <p>
              <span class="spanEle">收货地址：</span>
              <span
                class="realAddress"
                :title="item.address+item.detailed"
                v-text="item.address+item.detailed"
              >浙江省 杭州市 滨江区 中恒大厦</span>
            </p>
            <p>
              <span class="spanEle">实收货人：</span>
              <span
                class="realPhone"
                :title="item.name+' '+item.phone"
                v-text="item.name+' '+item.phone"
              >徐毛东 13620150159</span>
            </p>
            <div class="subBtn" @click="submitOrder()">提交订单</div>
          </div>
        </div>
      </template>
    </div>
    <div class="success" v-if="isDetail==5">
      <div class="sucLogo">
        <img src="../assets/cuizi.png" alt />
      </div>
      <div class="sucLogo" id="fukuan">
        <img :src="erweimageUrl" alt />
      </div>
      <p class="sucTitle" v-show="!moneyType">恭喜，付款成功！</p>
      <p class="sucTitle" v-show="moneyType">请用微信扫描二维码进行付款！</p>
      <p class="moneyEnd">
        <span class="spannnn">付款金额：</span>
        <span class="moneyNumSuc">¥{{total}}</span>
      </p>
      <div class="line"></div>
      <p class="oderDetailSuc">订单详情：</p>
      <p class="orderSort" v-for="(val,index) in idArr" :key="index">订单编号Num{{index+1}}:{{val}}</p>
      <template v-for="(item,index) in addressList">
        <p
          class="receivePeo"
          :key="index"
          :value="index"
          v-if="item.type==1"
          v-text="'收货人：'+item.name+' '+item.phone"
        >收货人：徐毛东 18392735153</p>
      </template>
      <template v-for="(item,index) in addressList">
        <p
          class="receiveAddress"
          :key="index"
          :value="index"
          v-if="item.type==1"
          v-text="'收货地址：'+item.address+item.detailed"
        >地址：浙江省杭州市江干区中恒大厦</p>
      </template>
      <!-- <p class="estabTime">创建时间：2019-01-17 23:17:12</p>
      <p class="payTime">付款时间：2019-01-17 23:17:12</p>-->
      <div class="line"></div>
      <div class="nextDiv">
        <p class="nextP">您还可以</p>
        <p class="go" @click="continueSee()">继续逛逛</p>—》
      </div>
    </div>
    <div class="hotPart" v-if="isDetail==6">
      <el-tabs v-model="GoodsClassifyIndex">
        <el-tab-pane
          v-for="(item,index) in secarhList"
          :key="index"
          :label="item.name"
          :name="'tab-'+index"
        >
          <div class="noDataDiv" v-show="item.list.length==0">
            <img src="../assets/noData.png" alt />
          </div>
          <p class="noDataP" v-show="item.list.length==0">暂无数据</p>
          <ul class="hotUl">
            <li
              v-for="(todo,num) in item.list"
              :key="num"
              :index="num"
              :style="{height:liHeight+'px'}"
              @click="seeDeatilOneSearch(0,num)"
            >
              <div class="imgParDiv" :style="{height:heightScOne+'px'}">
                <img :src="todo.imgurl.split(',')[0]" alt />
              </div>
              <p class="pTitle" v-text="todo.name">常开式电磁阀</p>
              <p
                class="pPrice"
                v-text="'¥ '+(todo.money==null||todo.money=='null'?0:todo.money)"
              >￥302.50</p>
            </li>
          </ul>
        </el-tab-pane>
        <!-- <el-tab-pane label="低功率电路模块" name="tab-1">
          <ul class="hotUl" >
            <li>
              <img src="../assets/3.png" alt>
              <p class="pTitle">常开式电磁阀</p>
              <p class="pPrice">￥302.50</p>
            </li>
            <li>
              <img src="../assets/2.png" alt>
              <p class="pTitle">常开式电磁阀</p>
              <p class="pPrice">￥302.50</p>
            </li>
            <li>
              <img src="../assets/1.png" alt>
              <p class="pTitle">常开式电磁阀</p>
              <p class="pPrice">￥302.50</p>
            </li>
            <li>
              <img src="../assets/4.png" alt>
              <p class="pTitle">常开式电磁阀</p>
              <p class="pPrice">￥302.50</p>
            </li>
            <li>
              <img src="../assets/3.png" alt>
              <p class="pTitle">常开式电磁阀</p>
              <p class="pPrice">￥302.50</p>
            </li>
            <li>
              <img src="../assets/3.png" alt>
              <p class="pTitle">常开式电磁阀</p>
              <p class="pPrice">￥302.50</p>
            </li>
            <li id="nouseLi">
              <img src="../assets/3.png" alt>
              <p class="pTitle">常开式电磁阀</p>
              <p class="pPrice">￥302.50</p>
            </li>
            <li id="nouseLi">
              <img src="../assets/3.png" alt>
              <p class="pTitle">常开式电磁阀</p>
              <p class="pPrice">￥302.50</p>
            </li>
            <li id="nouseLi">
              <img src="../assets/3.png" alt>
              <p class="pTitle">常开式电磁阀</p>
              <p class="pPrice">￥302.50</p>
            </li>
            <li id="nouseLi">
              <img src="../assets/3.png" alt>
              <p class="pTitle">常开式电磁阀</p>
              <p class="pPrice">￥302.50</p>
            </li>
          </ul>
        </el-tab-pane>-->
      </el-tabs>
    </div>
    <!-- <div class="addressDiv" v-html="htmlWord"></div> -->
  </div>
</template>
<script>
import $ from "jquery";
import navtab from "./navtab";
export default {
  name: "shopping",
  components: {
    navtab: navtab
  },
  inject: ["reload"],
  data() {
    return {
      hoverFlag: false,
      bodyHeight: 0,
      // htmlWord:
      //   "Copyright&nbsp©&nbsp2016-2019&nbsp浙江桃园科技有限公司&nbsp&nbsp|&nbsp&nbsp 技术支持：杭州互办网络科技有限公司",
      localname: "未登录",
      localuserphone: "未登录",
      headUrl: "",
      moneyType: true,
      erweimageUrl: "",
      localimgUrl: require("../assets/head.jpg"),
      input5: "",
      GoodsClassifyIndex: "tab-0",
      lunobo: [
        require("../assets/1.png"),
        require("../assets/2.png"),
        require("../assets/3.png"),
        require("../assets/4.png")
      ],
      activeName: "first",
      num: 1,
      isDetail: 1,
      num2: 1,
      user: "",
      orderNum: [0, 0, 0, 0],
      hots: [],
      GoodsClassify: [], //分类列表
      shopcartList: [], //购物车列表
      chooseAll: false, //时候全选
      moneyAll: 0, //购物车选中的钱
      numAll: 0, //购物车选择数量
      productId: "", //商品ID
      endOrder: {}, //商品资料
      typeList: [], //商品规格列表
      typeIndex: 0,
      commentList: [], //商品评论额列表
      normalMan: require("../assets/bj.png"),
      odrer: [],
      total: 0,
      sendMoney: 0,
      addressList: [],
      endOrder: "",
      idArr: [],

      secarhList: [],
      keyword: "",
      timeInterval: "",
      fromPath: "",
      name: "",
      nickName: "",
      sxList: [],
      heightScOne: "",
      liHeight: "",
      newLiH: "",
      newBosslih: "",
      ulH:""
    };
  },

  methods: {
    // 返回添加地址
    backToAddress() {
      var isAddAddress = 1;
      sessionStorage.setItem("isAddAddress", isAddAddress);
      this.$router.push("/perCenter");
    },
    // '/api/Shopping/goodsFormatById/'+goodid
    getSpSx(goodid) {
      this.isDetail = 2;
      //console.log(goodid);
      this.$axios({
        url: this.$http + "/api/Shopping/goodsFormatById/" + goodid,
        method: "get",
        cache: false,
        contentType: "application/JSON",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => {
        //console.log(res);
        if (res.data.code == 0) {
          this.sxList = res.data.Entity;
          //console.log(this.sxList);
        }
        // //console.log('这是商品属性'+res);
      });
    },
    //   标签页
    handleClick(tab, event) {
      //console.log(tab.index, event);
      this.GoodsClassifyIndex = "tab-" + tab.index;
      this.getClassGoods();
    },
    handleClickdetail(tab, event) {
      //console.log(tab, event);
    },
    back() {
      this.endOrder = "";
      this.newMethod();
      // if (this.fromPath == "/perCenter") {
      //   this.$router.push("/perCenter");
      //   this.isDetail = 1;
      //   this.moneyAll = 0;
      //   this.total = 0;
      //   this.numAll = 0;
      // } else {
      this.isDetail = 1;
      this.moneyAll = 0;
      this.total = 0;
      this.numAll = 0;
      // }
      // this.fromPath=""
    },
    handleChange(value) {
      //console.log(value);
    },
    seeSortDetail(index) {
      //console.log(index);
      this.productId = this.hots[index].id;
      // this.isDetail = 2;
      this.getSpSx(this.productId);
      this.getendOrderMes();
    },
    seeDeatil(index) {
      // this.getendOrderMes();
      //console.log(index);
      this.productId = this.hots[index].id;
      // this.isDetail = 2;
      this.getSpSx(this.productId);
    },
    //选择分类商品
    seeDeatilOne(index, num) {
      this.productId = this.GoodsClassify[index].list[num].id;
      this.isDetail = 2;
      this.getSpSx(this.productId);
    },
    seeDeatilOneSearch(index, num) {
      this.productId = this.secarhList[0].list[num].id;
      this.isDetail = 2;
      this.getSpSx(this.productId);
    },
    handleChangecar(size, index) {
      this.goodsCommentUpd(index, size, false);
    },
    continueSee() {
      this.isDetail = 1;
      this.total = 0;
      this.numAll = 0;
      this.moneyAll = 0;
    },
    seeShopCar() {
      if (sessionStorage.getItem("user")) {
        this.isDetail = 3;
      } else {
        this.$notify({
          title: "温馨提示",
          message: "您还没有登录交流圈，请先登录",
          type: "warning"
        });
        var flag = null;
        sessionStorage.setItem("flag", flag);
        this.$router.push("/");
      }
    },
    pay() {
      this.isDetail = 4;
    },
    toShopCar() {
      this.isDetail = 3;
      this.moneyAll = 0;
      this.total = 0;
      this.numAll = 0;
    },
    extend(target, source) {
      for (var obj in source) {
        target[obj] = source[obj];
      }
      return target;
    },
    // /api/Shopping/OrderInsert插入订单
    submitOrder() {
      //收货地址
      //console.log(this.addressList);
      if (this.addressList.length == 0) {
        this.$notify({
          title: "温馨提示",
          message: "请您先添加收货地址",
          type: "warning"
        });
      }
      // 总金额
      //console.log(this.moneyAll);
      // if (this.moneyAll == 0) {
      //   this.$notify({
      //     title: "温馨提示",
      //     message: "请您先添加商品",
      //     type: "warning"
      //   });
      // }
      //提交的购物车
      //console.log(JSON.parse(sessionStorage.getItem("order")));
      this.endOrder = JSON.parse(sessionStorage.getItem("order"));
      //console.log(this.total);
      var arr = [];
      for (var i = 0; i < this.endOrder.length; i++) {
        var mes = {
          userName: JSON.parse(sessionStorage.getItem("user")).userName,
          size: "",
          money: "",
          goodsId: "",
          goodsspecid: "",
          message: "",
          methods: "快递",
          goodsCartId: "",
          id: ""
        };
        var address = this.addressList[0];
        delete address["id"];
        // delete this.addressList[0].address;
        var mes = this.extend(mes, address);
        mes.size = this.endOrder[i].size;
        mes.money = this.endOrder[i].size * this.endOrder[i].price;
        mes.goodsId = this.endOrder[i].goodsEntity.id;
        mes.goodsspecid =
          this.endOrder[i].goodsspecEntity == null
            ? ""
            : this.endOrder[i].goodsspecEntity.id;

        if (this.endOrder[i].id != null) {
          mes.goodsCartId = this.endOrder[i].id;
          //console.log(this.endOrder[i].id);
          mes.id = this.endOrder[i].id;
        }
        delete mes["modifytime"];
        delete mes["createtime"];
        mes.type = 1;
        arr.push(mes);
      }
      //console.log(arr);
      let data = JSON.stringify(arr);
      //console.log(data);
      this.$axios({
        url: this.$http + "/api/Shopping/OrderInsert",
        method: "POST",
        cache: false,
        data: JSON.stringify(arr),
        contentType: "application/JSON",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => {
        //console.log(res);
        if (res.data.code == 0) {
          //console.log(res.data.Entity);
          this.idArr = [];
          res.data.Entity.forEach(element => {
            //console.log(element.id);
            this.idArr.push(element.id);
            //console.log(this.idArr);
            // this.getErweima();
            this.giveid();
          });
        }
      });
      // http://101.37.39.157:8080/huban-dcfadmin/api/WeChat/payCallBack
      // this.isDetail = 5;
      // 触发该事件结束以后将总金额归零，否则继续浏览时金额仍存在
      // this.total = 0;
      // this.numAll = 0;
      // this.moneyAll = 0;
    },
    // 获取订单的支付二维码  URL地址：https://api.mch.weixin.qq.com/pay/unifiedorder
    /* 
     公众账号ID	appid	是
     商户号	mch_id	是
     随机字符串	nonce_str	是
     签名	sign	是
     商品描述	body	是
     商户订单号	out_trade_no	是
     标价金额	total_fee	是
     终端IP	spbill_create_ip	是
     通知地址	notify_url	是
     交易类型	trade_type	是
    */
    //  后台统一下单
    giveid() {
      /*       param.put("body", jsonObject.getString("body")); // 内容(随意填,具体参照微信官方文档)
      param.put("out_trade_no", jsonObject.getString("out_trade_no")); // 订单号
      param.put("total_fee", jsonObject.getString("total_fee")); // 支付价格.<注意：这里的价格单位是分,必须是整数,不能带小数点的>
      param.put("spbill_create_ip", jsonObject.getString("spbill_create_ip")); // IP地址 ַ
      param.put("notify_url", jsonObject.getString("notify_url")); // 通知路径
      param.put("trade_type", "NATIVE"); // JSAPI-微信公众号支付 */
      //console.log(this.idArr);
      var str = [];
      for (var i = 0; i < this.idArr.length; i++) {
        str.push(this.idArr[i]);
      }
      // str +=']'
      let data = {
        body: { ids: str },
        total_fee: this.total,
        // total_fee: 0.01,
        notify_url:this.$http+'api/WeChat/payCallBack'
          // "http://115.29.185.211:8033/huban-dcfadmin/api/WeChat/payCallBack"
      };
      this.$axios({
        url: this.$http + "/api/WeChat/unifiedOrder",
        method: "POST",
        data: { data: JSON.stringify(data) },
        // contentType: "application/JSON",
        transformRequest: [
          function(data) {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            ret = ret.substring(0, ret.lastIndexOf("&"));
            return ret;
          }
        ],
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        //console.log(res);
        if (res.data.code == 0) {
          var that = this;
          this.isDetail = 5;
          this.erweimageUrl = res.data.msg;
          //console.log(this.erweimageUrl);
          this.$notify({
            title: "成功",
            message: "提交订单成功，请您扫描二维码进行支付！",
            type: "success"
          });
          // 定义定时器轮询 每隔0.5秒调用 getOderStatus方法获取订单状态
          this.timeInterval = setInterval(function() {
            that.getOderStatus();
          }, 1000);
        }
      });
    },

    // /api/Shopping/OrderByID/{OrderId}轮询查询单个订单(通过订单ID)
    getOderStatus() {
      //console.log("111");
      // 订单id idArr
      // 成功以后将moneyType变为false
      //展示支付成功的页面
      this.$axios({
        method: "GET",
        url: this.$http + "/api/Shopping/OrderByID/" + this.idArr[0]
        // data:{username:this.user.phone}
      }).then(res => {
        //console.log(res);
        var data = res.data;
        if (data.Entity.type == 2) {
          this.$notify({
            title: "成功",
            message: "支付成功，感谢小主",
            type: "success"
          });
          this.moneyType = false;
          // 当订单显示支付成功以后将moneyType变为false
          clearInterval(this.timeInterval);
        }
      });
    },
    //获取订单
    getOrder() {
      this.$axios({
        method: "GET",
        url: this.$http + "/api/Shopping/OrderByList/" + this.user.phone
        // data:{username:this.user.phone}
      }).then(res => {
        var data = res.data;
        if (data.code == 0) {
          //console.log(data.Entity);
          for (var i = 0; i < this.orderNum.length; i++) {
            for (var j = 0; j < data.Entity.length; j++) {
              if (i != 3) {
                if (data.Entity[j].type == i + 1) {
                  this.orderNum[i]++;
                  this.$forceUpdate();
                }
              } else {
                if (data.Entity[j].type == 0) {
                  this.orderNum[3]++;
                  this.$forceUpdate();
                }
              }
            }
          }
        }
      });
    },

    //获取广告条
    getBanner() {
      this.$axios({
        method: "GET",
        url: this.$http + "/api/Shopping/banner"
        // data:{username:this.user.phone}
      }).then(res => {
        //console.log(res);
        var data = res.data;
        if (data.code == 0) {
          //console.log(res);
          this.lunobo = data.Entity;
        }
      });
    },
    seeLunboDetail(index) {
      if (this.lunobo[index].mold == 2 && this.lunobo[index].identifier == 3) {
        this.productId = this.lunobo[index].inner;
        this.isDetail = 2;
      }
    },
    //热门商品
    getHots() {
      this.$axios({
        method: "GET",
        url: this.$http + "/api/Shopping/HotGoods"
        // data:{username:this.user.phone}
      }).then(res => {
        //console.log(res);
        var data = res.data;
        if (data.code == 0) {
          //console.log(res);
          this.hots = data.Entity;
          //console.log(this.hots);
        }
      });
    },

    //获取分类
    getClassify() {
      this.$axios({
        method: "GET",
        url: this.$http + "/api/Shopping/GoodsClassify"
        // data:{username:this.user.phone}
      }).then(res => {
        //console.log(res);
        var data = res.data;
        if (data.code == 0) {
          for (var i = 0; i < data.Entity.length; i++) {
            data.Entity[i].list = [];
          }
          this.GoodsClassify = data.Entity;
          this.getClassGoods();
        }
      });
    },

    //获取分类下的商品
    getClassGoods() {
      this.$axios({
        method: "POST",
        url:
          this.$http +
          "/api/Shopping/goodByList/" +
          this.GoodsClassify[this.GoodsClassifyIndex.split("-")[1]].id
        // data:{username:this.user.phone}
      }).then(res => {
        //console.log(res);
        var data = res.data;
        if (data.code == 0) {
          this.GoodsClassify[this.GoodsClassifyIndex.split("-")[1]].list =
            data.Entity;
        }
      });
    },

    //获取购物车
    goodsCarById() {
      this.$axios({
        method: "POST",
        url: this.$http + "/api/Shopping/goodsCarById/" + this.user.userName
        // data:{username:this.user.phone}
      }).then(res => {
        //console.log(res);
        var data = res.data;
        if (data.code == 0) {
          //console.log(data.Entity);
          for (var i = 0; i < data.Entity.length; i++) {
            if (data.Entity[i].goodsEntity == null) {
              data.Entity.splice(i, 1);
              i--;
            } else {
              data.Entity[i].choose = false;
              data.Entity[i].price = parseFloat(
                data.Entity[i].goodsspecEntity == null ||
                  data.Entity[i].goodsspecEntity == ""
                  ? data.Entity[i].goodsEntity.money
                  : data.Entity[i].goodsspecEntity.money
              );
            }
          }
          this.shopcartList = data.Entity;
          this.$forceUpdate();
          //console.log(this.shopcartList);
        }
      });
    },

    //选择购物车其中一种
    chooseOne(index) {
      this.shopcartList[index].choose = !this.shopcartList[index].choose;
      for (var i = 0; i < this.shopcartList.length; i++) {
        if (this.shopcartList[i].choose == false) {
          this.chooseAll = false;
          break;
        }
      }
      if (i == this.shopcartList.length) {
        this.chooseAll = true;
      }
      this.getAllNumMoney();
      //console.log(i);
      //console.log(this.shopcartList);
    },

    //选择所有商品
    chooseAllCart() {
      this.chooseAll = !this.chooseAll;
      for (var i = 0; i < this.shopcartList.length; i++) {
        this.shopcartList[i].choose = this.chooseAll;
      }
      this.getAllNumMoney();
      this.$forceUpdate();
    },

    //获取总量和总金额
    getAllNumMoney() {
      this.moneyAll = 0;
      this.numAll = 0;
      for (var i = 0; i < this.shopcartList.length; i++) {
        if (this.shopcartList[i].choose) {
          this.numAll += parseFloat(this.shopcartList[i].size);
          this.moneyAll += parseFloat(this.shopcartList[i].money);
        }
      }
      this.$forceUpdate();
    },

    //修改购物车
    goodsCommentUpd(index, size, del) {
      var that = this;
      if (del == false) {
        this.$axios({
          method: "POST",
          url: this.$http + "/api/Shopping/goodsCommentUpd",
          data: {
            id: that.shopcartList[index].id,
            size: size,
            money: size * parseFloat(that.shopcartList[index].price),
            userName: that.user.userName
          },
          headers: {
            "Content-Type": "application/json"
          }
        }).then(res => {
          //console.log(res);
          var data = res.data;
          if (data.code == 0) {
            this.shopcartList[index].money =
              parseFloat(this.shopcartList[index].price) *
              parseFloat(this.shopcartList[index].size);
            this.getAllNumMoney();
          }
        });
      } else {
        this.$axios({
          method: "POST",
          url:
            this.$http +
            "/api/Shopping/goodsCommentDel/" +
            that.shopcartList[index].id
          // data: JSON.stringify({
          //   id: that.shopcartList[index].id,
          //   size: size,
          //   money: size * parse(that.shopcartList[index].price),
          //   userName: that.user.userName
          // })
        }).then(res => {
          //console.log(res);
          var data = res.data;
          if (data.code == 0) {
            this.shopcartList.splice(index, 1);
            this.getAllNumMoney();
          }
        });
      }
    },

    //删除其中一个商品
    deleteShopCart(index) {
      this.goodsCommentUpd(index, 0, true);
    },

    //获取商品资料
    getendOrderMes() {
      var that = this;
      //获取商品资料
      this.$axios({
        method: "POST",
        url:
          this.$http +
          "/api/Shopping/goodById/" +
          that.productId +
          "/" +
          this.user.userName
        // data: JSON.stringify({
        //   id: that.shopcartList[index].id,
        //   size: size,
        //   money: size * parse(that.shopcartList[index].price),
        //   userName: that.user.userName
        // })
      }).then(res => {
        var data = res.data;
        if (data.code == 0) {
          this.endOrder = data.Entity;
          //console.log(this.endOrder);
        }
      });

      //获取商品规格
      this.$axios({
        method: "POST",
        url: this.$http + "/api/Shopping/goodsSpecById/" + that.productId
        // data: JSON.stringify({
        //   id: that.shopcartList[index].id,
        //   size: size,
        //   money: size * parse(that.shopcartList[index].price),
        //   userName: that.user.userName
        // })
      }).then(res => {
        var data = res.data;
        if (data.code == 0) {
          this.typeList = data.Entity;
        }
      });

      //获取商品评论
      this.$axios({
        method: "POST",
        url: this.$http + "/api/Shopping/goodsCommentById/" + that.productId
        // data: JSON.stringify({
        //   id: that.shopcartList[index].id,
        //   size: size,
        //   money: size * parse(that.shopcartList[index].price),
        //   userName: that.user.userName
        // })
      }).then(res => {
        var data = res.data;
        if (data.code == 0) {
          this.commentList = data.Entity;
        }
      });
    },

    //改变数量
    changeStock() {
      //console.log(this.num);
    },

    //收藏商品
    collect() {
      if (sessionStorage.getItem("user")) {
        var obj = { userName: this.user.userName, id: this.productId, type: 1 };
        this.$axios({
          method: "GET",
          url:
            this.$http +
            "/api/Yddatabase/Collection/" +
            obj.id +
            "/" +
            obj.userName +
            "/" +
            obj.type,
          // data: {
          //   id: that.shopcartList[index].id,
          //   size: size,
          //   money: size * parseFloat(that.shopcartList[index].price),
          //   userName: that.user.userName
          // },
          headers: {
            "Content-Type": "application/json"
          }
        }).then(res => {
          //console.log(res);
          var data = res.data;
          if (data.code == 0) {
            this.endOrder.collectType = this.endOrder.collectType == 1 ? 0 : 1;
          } else if (data.code == 500) {
            this.endOrder.collectType = this.endOrder.collectType == 1 ? 0 : 1;
          }
          this.$forceUpdate();
        });
      } else {
        var flag = null;
        sessionStorage.setItem("flag", flag);
        this.$router.push("/");
        this.$notify({
          title: "温馨提示",
          message: "为了给您更加优质的服务，请先登录",
          type: "warning"
        });
      }
    },

    //加入购物车和购买商品
    endOrderBuy(index) {
      if (sessionStorage.getItem("user")) {
        if (index == 0) {
          if (this.decideStock()) {
            var obj = {
              userName: this.user.userName,
              goodsId: this.productId,
              money:
                (this.typeList.length == 0
                  ? this.endOrder.money
                  : this.typeList[this.typeIndex].money) * this.num,
              size: this.num,
              goodsspecid:
                this.typeList.length == 0
                  ? null
                  : this.typeList[this.typeIndex].id
            };
            this.$axios({
              method: "POST",
              url: this.$http + "/api/Shopping/goodsCommentInsert",
              data: obj,
              headers: {
                "Content-Type": "application/json"
              }
            }).then(res => {
              //console.log(res);
              var data = res.data;
              if (data.code == 0) {
                this.isDetail = 3;
              }
            });
          }
        } else {
          // if (this.addressList.length == 0) {
          //   this.$confirm(
          //     "您还没有添加收货地址，请先返回添加, 是否继续?",
          //     "提示",
          //     {
          //       confirmButtonText: "确定",
          //       cancelButtonText: "取消",
          //       type: "warning"
          //     }
          //   )
          //     .then(() => {
          //       var isAddAddress = 1;
          //       sessionStorage.setItem("isAddAddress", isAddAddress);
          //       this.$router.push("/perCenter");
          //     })
          //     .catch(() => {
          //       this.$notify({
          //         title: "温馨提示",
          //         message: "已取消",
          //         type: "warning"
          //       });
          //     });
          // } else {
          if (this.decideStock()) {
            var order = {};
            order.goodsEntity = this.endOrder;
            if (this.typeList.length > 0) {
              order.goodsspecEntity = this.typeList[this.typeIndex];
              order.price = this.typeList[this.typeIndex].money;
            } else {
              order.price = this.endOrder.money;
            }
            order.size = this.num;
            var all = [];
            all.push(order);
            //console.log(order);
            sessionStorage.order = JSON.stringify(all);
            this.isDetail = 4;
            // }
          }
        }
      } else {
        this.$notify({
          title: "温馨提示",
          message: "为了给您更加优质的服务，请先登录",
          type: "warning"
        });
        var flag = null;
        sessionStorage.setItem("flag", flag);
        this.$router.push("/");
      }
    },
    //判断库存时候充足
    decideStock: function() {
      if (this.typeList.length == 0) {
        if (this.endOrder.stock >= this.num) {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.typeList[this.typeIndex].stock >= this.num) {
          return true;
        } else {
          return false;
        }
      }
    },

    //购物车去结算
    goPay() {
      //console.log(this.addressList);

      var order = [];
      for (var i = 0; i < this.shopcartList.length; i++) {
        if (this.shopcartList[i].choose) {
          order.push(this.shopcartList[i]);
        }
      }
      //console.log(order);
      if (order.length == 0) {
        this.$confirm("您还没有选择商品，请先添加, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            // this.$message({
            //   type: "success",
            //   message: "即将返回添加地址页面!"
            // });
            // var isAddAddress = 1;
            // sessionStorage.setItem("isAddAddress", isAddAddress);
            // this.$router.push("/perCenter");
          })
          .catch(() => {
            this.$notify({
              title: "温馨提示",
              message: "已取消",
              type: "warning"
            });
          });
        return;
      }
      sessionStorage.order = JSON.stringify(order);
      this.isDetail = 4;
      //console.log(this.moneyAll);
    },

    chooseAddress(index) {
      var obj = JSON.parse(JSON.stringify(this.addressList[index]));
      obj.type = 1;
      this.$axios({
        method: "POST",
        url: this.$http + "/api/personal/InsertOrUpdateUserAddress",
        data: obj,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => {
        //console.log(res);
        var data = res.data;
        if (data.code == 0) {
          this.$axios({
            method: "GET",
            url:
              this.$http +
              "/api/personal/SelectUserAddress/" +
              this.user.userName,
            // data: {
            //   id: that.shopcartList[index].id,
            //   size: size,
            //   money: size * parseFloat(that.shopcartList[index].price),
            //   userName: that.user.userName
            // },
            headers: {
              "Content-Type": "application/json"
            }
          }).then(res => {
            //console.log(res);
            var data = res.data;
            if (data.code == 0) {
              this.addressList = data.Entity;
              //console.log(this.addressList);
              if ((this.isDetail = 4)) {
                if (this.addressList.length == 0) {
                  this.$confirm(
                    "您还没有添加收货地址，请先返回添加, 是否继续?",
                    "提示",
                    {
                      confirmButtonText: "确定",
                      cancelButtonText: "取消",
                      type: "warning"
                    }
                  )
                    .then(() => {
                      // this.$message({
                      //   type: "success",
                      //   message: "即将返回添加地址页面!"
                      // });
                      var isAddAddress = 1;
                      sessionStorage.setItem("isAddAddress", isAddAddress);
                      this.$router.push("/perCenter");
                    })
                    .catch(() => {
                      this.$notify({
                        title: "温馨提示",
                        message: "已取消",
                        type: "warning"
                      });
                    });
                }
              }
            }
          });
        }
      });
    },

    //搜索商品
    searchComList() {
      this.$axios({
        method: "POST",
        url:
          this.$http +
          "/api/Shopping/recordInsert/" +
          this.user.userName +
          "/" +
          this.keyword
        // data: obj,
        // headers: {
        //   "Content-Type": "application/json"
        // }
      }).then(res => {
        //console.log(res);
        var data = res.data;
        if (data.code == 0) {
          // //console.log(this.secarhList[0].list,data.Entity)
          this.secrahList = [];
          var obj = { name: "搜索到的宝贝", list: [] };
          obj.list = data.Entity;
          this.secarhList.push(obj);
          //console.log(this.secarhList);
        }
      });
    },

    //收藏购物车某个商品
    collectShopcartOne(index) {
      //console.log(this.shopcartList[index]);
      var obj = {
        userName: this.user.userName,
        id: this.shopcartList[index].goodsEntity.id,
        type: 1
      };
      this.$axios({
        method: "GET",
        url:
          this.$http +
          "/api/Yddatabase/Collection/" +
          obj.id +
          "/" +
          obj.userName +
          "/" +
          obj.type,
        // data: {
        //   id: that.shopcartList[index].id,
        //   size: size,
        //   money: size * parseFloat(that.shopcartList[index].price),
        //   userName: that.user.userName
        // },
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => {
        //console.log(res);
        var data = res.data;
        if (data.code == 0) {
          this.shopcartList[index].goodsEntity.collectType =
            this.shopcartList[index].goodsEntity.collectType == 1 ? 0 : 1;
        } else if (data.code == 500) {
          this.shopcartList[index].goodsEntity.collectType =
            this.shopcartList[index].goodsEntity.collectType == 1 ? 0 : 1;
        }
        //console.log(this.shopcartList[index].goodsEntity);
        this.$forceUpdate();
      });
    },
    newMethod() {
      var swiper = new Swiper(".swiper-container", {
        pagination: ".swiper-pagination",
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        slidesPerView: 3,
        paginationClickable: true,
        spaceBetween: 30,
        freeMode: true,
        autoplay: 800 //可选选项，自动滑动
      });
    },
    addScroll() {
      //console.log("111");
      var maxScroolH = this.hots.length * (this.newBosslih + 15) + 20;
      //console.log(document.getElementById("sortHort").scrollTop);
      // if(document.getElementById('sortHort').scrollTop!=0){
      document.getElementById("sortHort").scrollTop =
        document.getElementById("sortHort").scrollTop - this.newBosslih;
      // }
    },
    reduceScroll() {
      //console.log("222");
      //console.log(document.getElementById("sortHort").scrollTop);
      document.getElementById("sortHort").scrollTop =
        document.getElementById("sortHort").scrollTop + this.newBosslih;
    },
    newSwiper(){
      var swiper = new Swiper(".swiper-container", {
      // 修改swiper自己或子元素时，自动初始化swiper
      observer: true,
      // 修改swiper的父元素时，自动初始化swiper
      observeParents: true,
      pagination: ".swiper-pagination",
      slidesPerView: 3,
      paginationClickable: true,
      spaceBetween: 30,
      freeMode: true
    });
    }
  },

  created() {
    clearInterval(this.timeInterval);
    if (sessionStorage.getItem("user")) {
      this.user = JSON.parse(sessionStorage.getItem("user"));
      //console.log(this.user);
      this.headUrl = this.user.headUrl;
      this.nickName = this.user.nickName;
      this.name = this.user.name;
    }
    this.getOrder();
    this.getBanner();
    this.getHots();
    this.getClassify();
    if (sessionStorage.isDetail != undefined) {
      this.isDetail = sessionStorage.isDetail;
      sessionStorage.removeItem("isDetail");
    }
    if (sessionStorage.routerDetailId != undefined) {
      this.productId = JSON.parse(sessionStorage.getItem("routerDetailId"));
      this.isDetail = 2;
      sessionStorage.removeItem("routerDetailId");
    }    // if (JSON.parse(sessionStorage.getItem("fromPath")) != undefined) {
    //   //console.log(JSON.parse(sessionStorage.getItem("fromPath")));
    //   this.fromPath = JSON.parse(sessionStorage.getItem("fromPath"));
    // }
  },
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     //console.log(from);
  //     //console.log(from.fullPath);
  //     if (from.fullPath == "/perCenter") {
  //       //console.log(JSON.parse(sessionStorage.getItem("routerDetailId")));
  //       this.productId = JSON.parse(sessionStorage.getItem("routerDetailId"));
  //       this.isDetail = 2;
  //     }
  //   });
  // },
  mounted() {
    this.newSwiper();
    var liW = (document.body.clientWidth * 0.8 - 23 - 20) * 0.156;
    this.heightScOne = (liW * 237.25) / 247.438;
    this.liHeight = this.heightScOne + 40 + 11 * 2 + 18 + 15;
    //console.log(this.liHeight);
    //console.log(247.438 / 237.25, liW / this.heightScOne);
    var newLiW = document.body.clientWidth * 0.14 * 0.8;
    this.newLiH = (newLiW * 237.25) / 247.438;
    this.newBosslih = this.newLiH + 20 + 34 + 22 + 10;
    // this.getHots();
    // //console.log(this.hots);
    // if(this.hots.length>6){
    //   //console.log(this.ulH=this.newBosslih,this.hots.length);
       this.ulH=this.newBosslih*5+20;
    // }else{
    //   //console.log(this.ulH=this.newBosslih,this.hots.length);
    //    this.ulH=this.newBosslih*this.hots.length;
    // }
    this.newMethod();
    clearInterval(this.timeInterval);
    if (sessionStorage.isAddAddress == 1) {
      this.isDetail = 4;
      sessionStorage.removeItem("isAddAddress");
    }
    // //console.log(JSON.parse(sessionStorage.getItem("routerDetailId")));
    // if (JSON.parse(sessionStorage.getItem("routerDetailId"))) {
    //   //console.log("333");
    // }
    // if(JSON.parse(sessionStorage.getItem(routerDetailId))){
    // }
  },
  watch: {
    isDetail: {
      handler: function(val, oldval) {
        setTimeout(() => window.scrollTo(0, 0), 150);
        // clearInterval(this.timeInterval);
        this.chooseAll = false;
        if (val == 3) {
          this.goodsCarById();
        } else if (val == 2) {
          this.getendOrderMes();
          document.getElementsByClassName("thingDetailLeft").offsetHeight;
          document.getElementsByClassName("thingDetail").offsetHeight;
          //console.log(
          //   document.getElementsByClassName("thingDetailLeft"),
          //   document.getElementsByClassName("thingDetail")
          // );
          if (
            document.getElementsByClassName("thingDetailLeft") >
            document.getElementsByClassName("thingDetail")
          ) {
            //console.log(this.bodyHeight);
          }
        } else if (val == 4) {
          //console.log(sessionStorage.order);
          this.order = JSON.parse(sessionStorage.order);
          for (var i = 0; i < this.order.length; i++) {
            this.total += this.order[i].price * this.order[i].size;
            this.all += this.order[i].size;
            if (this.order[i].goodsEntity.ornot == 0) {
              this.sendMoney += this.order[i].goodsEntity.frees;
            }
          }
          this.total += this.sendMoney;
          this.$axios({
            method: "GET",
            url:
              this.$http +
              "/api/personal/SelectUserAddress/" +
              this.user.userName,
            // data: {
            //   id: that.shopcartList[index].id,
            //   size: size,
            //   money: size * parseFloat(that.shopcartList[index].price),
            //   userName: that.user.userName
            // },
            headers: {
              "Content-Type": "application/json"
            }
          }).then(res => {
            //console.log(res);
            var data = res.data;
            if (data.code == 0) {
              this.addressList = data.Entity;
            }
          });
        } else if (val == 6) {
          this.searchComList();
        } else if (val == 1) {
          this.reload();
        }
      },
      deep: true //对象内部的属性监听，也叫深度监听
    }
  }
};
</script>

<style>
.shopping {
  background-color: #f1f1f1;
  overflow: hidden;
}
.shopping .navTab{
    box-shadow: 0px 4px 8px 0px rgba(102, 102, 102, 0.2);
  z-index:999;
}
.shopping .noDataDiv {
  width: 98px;
  height: 86px;
  /* background-color: pink; */
  margin: 0 auto;
  margin-top: 10%;
}
.shopping .noDataP {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  margin-top: 17px;
}
.shopping .noDataDiv img {
  display: block;
  width: 100%;
  height: 100%;
}
.swiper-container {
  width: 100%;
  height: 183px;
  margin-top: 10px auto 0;
  /* margin: 20px auto; */
  padding: 20px 0;
}
.showArrow {
  opacity: 0 !important;
}
.swiper-container:hover .showArrow {
  opacity: 1!important;
}
.newThing .swiper-button-next,
.newThing .swiper-button-prev {
  position: absolute;
  top: 50%;
  width: 52px;
  height: 24px;
  margin-top: -22px;
  z-index: 10;
  cursor: pointer;
  -moz-background-size: 27px 44px;
  -webkit-background-size: 27px 44px;
  background-size: 27px 44px;
  background-position: center;
  background-repeat: no-repeat;
}
.swiper-slide {
  text-align: center;
  font-size: 16px;
  background: #fff;
  /* background-color: green; */
  width: 276px !important; /* 380 */
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.swiper-container-free-mode > .swiper-wrapper div {
  width: 276px !important;
  margin-right: 5px !important;
  margin-left: 0px !important;
  position: relative;
}
#swiperImg {
  display: block;
  /* width: 487.333px; */
  max-width: 360px;
  max-height: 100%;
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
/* ------------------------ */
#fukuan {
  width: 200px;
  height: 200px;
}
.shopping #newclass {
  color: red;
}
.shopping .el-tabs__item.is-active {
  color: #158DD3;
}
.shopping #tis {
  color: #158DD3;
  font-weight: 600;
}
.shopping #nouseLi {
  opacity: 0;
}
.shopping .el-select .el-input {
  width: 130px;
}
.shopping .input-with-select .el-input-group__prepend {
  background-color: #fff;
}
/* .shopping {
  background-color: #f1f1f1;
} */
.shopping .top {
  width: 80%;
  /* background-color: #fff; */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 420px;
  margin: 0 auto;
  margin-top: 18px;
  /* padding: 30px; */
}
.shopping .top .topleft {
  width: 20%;
  background-color: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-image: url("../assets/bj.png");
  background-size: 100%;
  background-repeat: no-repeat;
  box-shadow: 0px 9px 20px 0px rgba(92, 92, 92, 0.1);
}
.shopping .top .topleft .headImg {
  height: 81px;
  width: 81px;
  margin: 0 auto;
  border-radius: 50%;
  overflow: hidden;
  margin-top: 30px;
  box-shadow: 0px 9px 20px 0px rgba(92, 92, 92, 0.1);
}
.shopping .top .topleft .headImg img {
  display: block;
  width: 100%;
  height: 100%;
}
.shopping .top .topleft .perName {
  width: 100%;
  text-align: center;
  font-size: 16px;
  margin-top: 10px;
}
.shopping .top .topleft .phone {
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: #ccc;
  margin: 10px 0;
}
.shopping .top .topleft .tabStatus {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.shopping .top .topleft .tabStatus .tabLi {
  width: 25%;
  height: 60px;
  /* background-color: yellow; */
}
.shopping .top .topleft .tabStatus .tabLi .num {
  width: 100%;
  text-align: center;
  font-size: 12px;
  height: 30px;
  line-height: 30px;
  color: #158DD3;
  /* font-weight: 600; */
}
.shopping .top .topleft .tabStatus .tabLi .tabWord {
  width: 100%;
  text-align: center;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
}
.shopping .top .topleft .shopCar {
  width: 72%;
  height: 45px;
  line-height: 45px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-size: 14px;
  color: #fff;
  background-color: #158DD3;
  margin: 0 auto;
  margin-top: 18%;
  cursor: pointer;
  box-shadow: 0px 9px 20px 0px rgba(92, 92, 92, 0.1);
  border-radius: 4px;
}
.shopping .top .topleft .shopCar .carIcon {
  height: 45px;
  line-height: 45px;
  font-size: 15px;
  margin-right: 20px;
}
.shopping .top .lunbo {
  width: 79%;
  height: 100%;
  background-color: #fff;
  border-radius: 5px;
  overflow: hidden;
}
.shopping .top .lunbo .block {
  width: 100%;
  height: 100%;
  /* background-color: green; */
}
.shopping .top .lunbo .block div {
  display: block;
  /* width: 100%;
  height: 100%; */
}
.shopping .top .lunbo .block div .el-carousel__container {
  display: block;
  width: 100%;
  height: 100%;
}
.shopping .top .lunbo .block img {
  display: block;
  /* max-width: 100%;
  max-height: 100%;
  margin: 0 auto; */
  width: 100%;
  height: 100%;
  /* margin: 0 auto; */
}
.shopping .inputPart {
  width: 80%;
  margin: 0 auto;
  height: 42px;
  background-color: #fff;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 10px 0;
  box-shadow: 0px 9px 20px 0px rgba(92, 92, 92, 0.1);
}
.shopping .inputPart .inputDiv {
  position: relative;
  width: 80%;
  margin-left: 6%;
}
.shopping .inputPart .inputDiv,
.shopping .inputPart .inputDiv .el-input-group {
  height: 100%;
}
.shopping .el-input-group {
  line-height: normal;
  display: inline-table;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  /* position: absolute;
    left: 0;
    top: 0; */
}
.shopping .inputPart .inputDiv .el-input__inner {
  height: 100%;
}
.shopping .el-input-group__append {
  background-color: #158DD3;
  font-size: 12px;
  color: #fff;
}
.shopping .newThing {
  width: 80%;
  margin: 0 auto;
  /* height: 260px; */
  background-color: #fff;
  /* margin-bottom: 50px; */
  /* padding: 30px; */
  padding-top: 20px;
}
.shopping .newThing .newLogo {
  width: 6%;
  height: 24px;
  /* margin-top: 20px; */
  margin-left: 20px;
}
.shopping .newThing .newLogo img {
  display: block;
  width: 100%;
  height: 100%;
}
.shopping .newThing .newUl {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  /* height: 90%; */
  margin-top: 30px;
  /* overflow: scroll; */
  flex-wrap: wrap;
}
.shopping .newThing .newUl li {
  height: 260px;
  width: 22%;
  cursor: pointer;
}
.shopping .newThing .newUl li img {
  display: block;
  width: 100%;
  height: 100%;
}
.shopping .hotPart {
  width: 80%;
  margin: 0px auto;
  /* height: 600px; */
  /* padding: 30px; */
  background-color: #fff;
  margin-top: 20px;
  box-shadow: 0px 9px 20px 0px rgba(92, 92, 92, 0.1);
}
.shopping .hotPart .el-tabs__content {
  margin: 0 20px 30px 23px;
}
.shopping .hotPart .hotUl {
  width: 100%;
  /* height: 100%; */
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.shopping .hotPart .hotUl li {
  width: 15.6%;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: wrap;
  cursor: pointer;
  /* margin-right: 1%; */
  margin: 0 0.5%;
  /* margin-bottom: 10px; */
  /* position: relative; */
}
/* .shopping .hotPart .hotUl li .newImgDiv {
  width: 100%;
  height: 60%;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
} */
.shopping .hotPart .hotUl li .imgParDiv {
  width: 100%;
  height: 62%;
  position: relative;
  /* border: 1px solid #f1f1f1; */
}
.shopping .hotPart .hotUl li img {
  display: block;
  position: absolute;
  max-width: 100%;
  max-height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.shopping .hotPart .hotUl li .pTitle {
  width: 100%;
  height: 40px;
  font-size: 14px;
  text-align: left;
  margin: 11px 0;
  /* text-overflow: ellipsis; */
  /* white-space: nowrap; */
  /* word-break: break-all; */
  word-wrap: normal;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  /* position: absolute;
  bottom: 14%; */
}
.shopping .hotPart .hotUl li .pPrice {
  width: 100%;
  font-size: 14px;
  text-align: left;
  color: red;
  padding-top: 15px;
  height: 18px;
  /* position: absolute;
  bottom: 6%; */
}
.shopping .thingDetail {
  width: 70%;
  margin: 0 auto;
  margin-top: 20px;
  background-color: #fff;
  padding: 5px 0;
  /* position: absolute;
  top: 80px;
  right: 7%; */
  float: right;
  margin-right: 7%;
  z-index: 99;
}
.shopping .thingDetail .back {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: left;
  /* color: #fff; */
  /* background-color: #158DD3; */
  font-size: 16px;
  /* margin-left: 30px; */
  /* margin-bottom: 20px; */
  cursor: pointer;
  /* border-radius: 5px; */
  border-bottom: 1px solid #d8d8d8;
  text-indent: 1em;
  font-size: 14px;
}
.shopping .thingDetail .detailPart {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 426px;
  margin-bottom: 20px;
}
.shopping .thingDetail .detailPart .detailImg {
  height: 100%;
  width: 30%;
  position: relative;
  margin-left: 20px;
}
.imgParNewDiv {
  width: 100%;
  height: 100%;
  position: relative;
}
.imgParNewDiv img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
/* .shopping .thingDetail .detailPart .detailImg img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
} */
.shopping .thingDetail .detailPart .rigDesc {
  width: 66%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  /* background-color: #fff; */
}
.shopping .thingDetail .detailPart .rigDesc .cpPart {
  /* background-color: #f9f9f9; */
  width: 72%;
  /* padding: 0 20px; */
  margin: 20px 0;
  position: relative;
  background-image: url("../assets/spbj.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 6px 0;
}
/* .shopping .thingDetail .detailPart .rigDesc .cpPart::before {
  background-image: url("../assets/spbj.png");
  background-repeat: no-repeat;
  background-size: cover;
  filter: blur(2px);
  width: 100%;
  height: 100%;
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  z-index: 0;
} */
.shopping .thingDetail .detailPart .rigDesc .cpPart .cpName {
  width: 95%;
  margin: 0 auto;
  text-align: left;
  font-size: 22px;
  line-height: 36px;
  font-weight: 600;
  /* text-indent: 1em; */
  margin-top: 14px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.shopping .thingDetail .detailPart .rigDesc .cpPart .cpPrice {
  width: 95%;
  margin: 0 auto;
  text-align: left;
  font-size: 24px;
  line-height: 30px;
  color: red;
  margin-top: 20px;
  text-indent: 1em;
}
.shopping .thingDetail .detailPart .rigDesc .cpPart > p {
  background: transparent;
  z-index: 10;
  position: relative;
}
.shopping .thingDetail .detailPart .rigDesc .cpStatus {
  /* height: 118px; */
  /* width: 80%; */
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 0 0;
  border: 1px solid #ccc;
  margin-top: 1%;
  width: 72%;
  border-radius: 6px;
  padding: 10px 0;
  border: 1px solid rgba(191, 191, 191, 1);
}
.shopping .thingDetail .detailPart .rigDesc .cpStatus li {
  width: 21%;
  height: 60px;
  /* background-color: yellow; */
}
.shopping .thingDetail .detailPart .rigDesc .cpStatus li p {
  width: 100%;
  height: 50%;
  text-align: center;
  line-height: 45px;
}
.shopping .thingDetail .detailPart .rigDesc .cpStatus li .num {
  font-size: 22px;
  color: red;
}
.shopping .thingDetail .detailPart .rigDesc .cpStatus li .statusDesc {
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
}
.shopping .thingDetail .detailPart .rigDesc .carNumPart .sopNum {
  font-size: 14px;
  line-height: 40px;
  height: 100%;
  margin-right: 26px;
}
.shopping .thingDetail .detailPart .rigDesc .carNumPart .carInput {
  width: 26%;
  height: 100%;
}
.shopping .thingDetail .detailPart .rigDesc .operatePart {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 72%;
  margin: 0 0;
  margin-top: 1%;
  /* padding: 0 20px; */
}
.shopping .thingDetail .detailPart .rigDesc .operatePart li {
  width: 21%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.shopping .thingDetail .detailPart .rigDesc .operatePart .save {
  background-color: #d7e5fe;
  color: #158DD3;
  border-radius: 2px;
}
.shopping .thingDetail .detailPart .rigDesc .operatePart .shopNow {
  background-color: #158DD3;
  border-radius: 2px;
}
.shopping .thingDetail .detailPart .rigDesc .operatePart .addCar {
  background-color: #158DD3;
  border-radius: 2px;
}
.shopping .thingDetail .commentUl {
  width: 94%;
  margin-left: 46px;
}
.shopping .thingDetail .commentUl li {
  width: 100%;
  /* background-color: pink; */
  margin: 10px 0;
  /* height: 50px; */
  /* border-bottom: 1px solid #f1f1f1; */
}
.shopping .thingDetail .commentUl li .commentLef {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  /* background-color: green; */
  position: relative;
}
.shopping .thingDetail .commentUl li .commentLef .commentHeadImg {
  height: 50px;
  width: 50px;
  overflow: hidden;
  margin-right: 30px;
  border-radius: 50%;
}
.shopping .thingDetail .commentUl li .commentLef .commentHeadImg img {
  display: block;
  width: 100%;
  height: 100%;
}
.shopping .thingDetail .commentUl li .commentLef .commentName {
  height: 100%;
  line-height: 50px;
  font-size: 15px;
}
.shopping .thingDetail .commentUl li .commentLef .commentTime {
  height: 100%;
  line-height: 50px;
  font-size: 15px;
  /* background-color: pink; */
  position: absolute;
  right: 1%;
  color: #a9a9a9;
}
.shopping .thingDetail .commentUl li .content {
  /* height: 50px; */
  font-size: 14px;
  text-align: left;
  line-height: 30px;
  color: #7d7a7a;
  text-indent: 6em;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.shopping .shopCarDetail {
  width: 80%;
  margin: 0 auto;
  background-color: #fff;
  margin-top: 30px;
  min-height: 100vh;
  padding-top: 20px;
  padding-bottom: 100px;
}
.shopping .shopCarDetail .topPart {
  width: 100%;
  position: relative;
  border-bottom: 1px solid #ccc;
}
.shopping .shopCarDetail .topPart .backSee {
  /* width: 8%; */
  height: 40px;
  line-height: 40px;
  text-align: center;
  /* background-color: #158DD3; */
  font-size: 14px;
  color: black;
  position: absolute;
  /* top: 20px; */
  left: 20px;
  cursor: pointer;
  /* border-radius: 4px; */
}
.shopping .shopCarDetail .topPart .shopTitle {
  width: 50%;
  margin: 0 auto;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 15px;
}
.shopping .shopCarDetail .allInput {
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 30px;
  margin: 18px auto;
}
.shopping .shopCarDetail .allInput input {
  width: 16px;
  height: 30px;
  margin-right: 30px;
}
.shopping .shopCarDetail .allInput p {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.shopping .shopCarDetail .gjTab {
  width: 80%;
  margin: 10px auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 40px;
  background-color: #f9f9f9;
}
.shopping .shopCarDetail .gjTab li {
  width: 17.5%;
  height: 100%;
  line-height: 40px;
  text-align: center;
  font-size: 15px;
}
.shopping .shopCarDetail .gjTab .baby {
  width: 30%;
}
.shopping .shopCarDetail .gjTab .baby .operateLi {
  width: 25%;
}
.shopping .shopCarDetail .spUl {
  width: 80%;
  margin: 30px auto;
  margin-bottom: 100px;
}
.shopping .shopCarDetail .spUl li {
  width: 100%;
  height: 150px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 20px;
  /* padding-bottom: 5px; */
  border: 1px solid rgba(228, 239, 255, 1);
}
.shopping .shopCarDetail .spUl li .spDesc {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 30%;
  border-right: 1px solid rgba(228, 239, 255, 1);
}
.shopping .shopCarDetail .spUl li .spDesc .imgDIv {
  width: 42%;
  height: 100%;
  position: relative;
}
.shopping .shopCarDetail .spUl li .spDesc .imgDIv img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  min-width: 80%;
  min-height: 80%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.shopping .shopCarDetail .spUl li .spDesc .spName {
  width: 46%;
  height: 80%;
  text-align: left;
  line-height: 22px;
  font-size: 16px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  padding-left: 14px;
  padding-top: 17px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.shopping .shopCarDetail .spUl li .spDesc .oneCheck {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 16px;
  height: 16px;
  cursor: pointer;
  -webkit-appearance: radio;
}
.shopping .shopCarDetail .spUl li .priceOne {
  width: 17.5%;
  height: 100%;
  font-size: 14px;
  line-height: 150px;
  border-right: 1px solid rgba(228, 239, 255, 1);
}
.shopping .shopCarDetail .spUl li .inputDiv {
  width: 17.5%;
  height: 100%;
  line-height: 150px;
  border-right: 1px solid rgba(228, 239, 255, 1);
}
.shopping .shopCarDetail .spUl li .money {
  width: 17.5%;
  height: 100%;
  font-size: 20px;
  line-height: 150px;
  font-weight: 600;
  border-right: 1px solid rgba(228, 239, 255, 1);
}
.shopping .shopCarDetail .spUl li .operateOne {
  width: 17.5%;
  height: 100%;
}
.shopping .shopCarDetail .spUl li .operateOne div {
  height: 30%;
  width: 100%;
  text-align: center;
  line-height: 100px;
  font-size: 14px;
  cursor: pointer;
}
.shopping .shopCarDetail .spUl li .operateOne div:hover {
  color: red;
  font-weight: 600;
}
.shopping .shopCarDetail .fixedDiv {
  height: 60px;
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: fixed;
  bottom: 0px;
  z-index: 999;
  /* box-shadow: 0px -10px 0px 0px #ccc; */
  box-shadow: 0px 5px 10px 0px rgba(15, 19, 69, 0.3);
  background-color: #fff;
}
.shopping .shopCarDetail .fixedDiv .fixedLef {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  position: relative;
}
.shopping .shopCarDetail .fixedDiv .fixedLef input {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  left: 50px;
  -webkit-appearance: radio;
}
.shopping .shopCarDetail .fixedDiv .fixedLef p {
  height: 100%;
  font-size: 14px;
  line-height: 60px;
  margin-left: 100px;
}
.shopping .shopCarDetail .fixedDiv .fixedRig {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 50%;
}
.shopping .shopCarDetail .fixedDiv .fixedRig .checkedNum {
  height: 100%;
  font-size: 14px;
  line-height: 60px;
}
.shopping .shopCarDetail .fixedDiv .fixedRig .totalPrice {
  height: 100%;
  font-size: 14px;
  line-height: 60px;
  margin: 0 30px;
}
.shopping .shopCarDetail .fixedDiv .fixedRig .giveBtn {
  width: 16%;
  height: 100%;
  text-align: center;
  line-height: 60px;
  color: #fff;
  font-size: 14px;
  background-color: #158DD3;
  cursor: pointer;
}
.shopping .payMoney {
  width: 80%;
  margin: 0 auto;
  margin-top: 30px;
  background-color: #fff;
  /* padding-top: 30px;
  padding-left: 50px;
  padding-right: 50px; */
  min-height: 100vh;
  padding-bottom: 32px;
}

.shopping .payMoney .backDiv {
  width: 98%;
  height: 50px;
  line-height: 50px;
  text-align: left;
  color: #0a0a0a;
  /* background-color: #158DD3; */
  /* margin-top: 10px; */
  cursor: pointer;
  /* border-radius: 3px; */
  border-bottom: 1px solid #ccc;
  padding-left: 22px;
}
.shopping .payMoney .chooseTitle {
  font-size: 15px;
  line-height: 50px;
  width: 100%;
  text-align: left;
  margin-left: 30px;
}
.shopping .payMoney .addressUl {
  display: flex;
  flex-direction: row;
  /* justify-content: space-between; */
  width: 100%;
  flex-wrap: wrap;
  margin-left: 30px;
}

.shopping .payMoney .addressUl .addressLi {
  width: 20%;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 6px;
  padding-left: 10px;
  padding-right: 3px;
  margin-right: 10px;
  cursor: pointer;
  background: rgba(255, 255, 255, 1);
  border-radius: 6px;
  border: 1px solid rgba(220, 220, 220, 1);
  box-shadow: 0px 4px 6px 0px rgba(74, 74, 74, 0.1);
  margin-bottom: 10px;
  /* box-sizing: border-box; */
}
.shopping .payMoney .addressUl .addressLi:hover {
  border: 1px solid #158DD3;
  box-shadow: 0px 4px 6px 0px rgba(74, 74, 74, 0.1);
}
.shopping .payMoney .addressUl .addressLi .nameP {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 20px;
  height: 36px;
  line-height: 36px;
}
/* .shopping .payMoney .addressUl .addressLi .nameP .addressName{
    width: 70%;
} */
.shopping .payMoney .addressUl .addressLi .nameP .isDefault {
  font-size: 14px;
  color: #ccc;
  /* width: 10%; */
  text-align: right;
  font-weight: 600;
  color: #158DD3;
}
.shopping .payMoney .addressUl .addressLi .addressP,
.shopping .payMoney .addressUl .addressLi .addressPhone,
.shopping .payMoney .addressUl .addressLi .AddressEmail {
  width: 100%;
  text-align: left;
  font-size: 14px;
  line-height: 26px;
}
.shopping .payMoney .addressUl .addressLi .addressP {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.shopping .payMoney .yesInfo {
  width: 100%;
  text-align: left;
  font-size: 15px;
  margin: 15px 0;
  margin-left: 30px;
}
.shopping .payMoney .yesTab {
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 40px;
  line-height: 40px;
  /* background-color: #f1f1f1; */
  background-color: #b9d1fa;
  margin-left: 50px;
}
.shopping .payMoney .yesTab li {
  width: 20%;
  height: 100%;
  font-size: 14px;
  text-align: center;
}
.shopping .payMoney .yesTab .yesTabBaby {
  width: 40%;
}
.shopping .payMoney .yesSpUl {
  width: 80%;
  margin-top: 23px;
  margin-left: 50px;
}
.shopping .payMoney .yesSpUl .yesLi {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 140px;
  border: 1px solid #b9d1fa;
  margin: 20px 0;
  /* padding: 3px; */
}
.shopping .payMoney .yesSpUl .yesLi .yesLiBaby {
  width: 40%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.shopping .payMoney .yesSpUl .yesLi .yesLiBaby .babyImg {
  width: 48%;
  height: 100%;
}
.newA {
  width: 100%;
  height: 100%;
  position: relative;
}
.realAddress {
  width: 70%;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-align: right;
}
.shopping .payMoney .yesSpUl .yesLi .yesLiBaby .babyImg img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.shopping .payMoney .yesSpUl .yesLi .yesLiBaby .babyName {
  width: 50%;
  height: 100%;
  font-size: 14px;
  line-height: 30px;
  text-align: left;
  padding-left: 3px;
}
.shopping .payMoney .yesSpUl .yesLi .babyPrice {
  width: 20%;
  height: 100%;
  font-size: 14px;
  line-height: 30px;
  line-height: 140px;
  border-left: 1px solid #b9d1fa;
  border-right: 1px solid #b9d1fa;
}
.shopping .payMoney .yesSpUl .yesLi .babyNum {
  width: 20%;
  height: 100%;
  font-size: 14px;
  line-height: 30px;
  line-height: 140px;
  border-right: 1px solid #b9d1fa;
}
.shopping .payMoney .yesSpUl .yesLi .BabyAllPrice {
  width: 20%;
  height: 100%;
  font-size: 14px;
  line-height: 140px;
  color: red;
  font-weight: 600;
}
.shopping .payMoney .orderDiv {
  width: 400px;
  /* height: 185px; */
  border-radius: 6px;
  border: 1px solid #ff6a00;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin: 100px 0;
  margin-left: 50px;
  /* position: fixed;
  bottom: 300px;
  left: 210px;
  background-color: #fff;
  z-index:999; */
}
.shopping .payMoney .orderDiv {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.shopping .payMoney .orderDiv p {
  width: 90%;
  margin: 2% auto;
  height: 30px;
  line-height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.shopping .payMoney .orderDiv p .spanEle {
  font-size: 15px;
  color: #ccc;
}
.shopping .payMoney .orderDiv p .realMoney {
  font-size: 30px;
  color: #ff6a00;
}
.shopping .payMoney .orderDiv .subBtn {
  width: 100%;
  height: 58px;
  line-height: 58px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  background-color: #ff6a00;
  cursor: pointer;
  border: 1px solid #ff6a00;
  margin-left: -1px;
}
.shopping .success {
  width: 80%;
  margin: 0 auto;
  margin-top: 30px;
  background-color: #fff;
  /* min-height: 90vh; */
  padding-top: 2%;
}
.shopping .success .sucLogo {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  margin-top: 3%;
}
.shopping .success .sucLogo img {
  display: block;
  width: 100%;
  height: 100%;
}
.shopping .success .sucTitle {
  width: 100%;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #158DD3;
  margin-top: 1%;
}
.shopping .success .moneyEnd {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 1% 0;
}
.shopping .success .moneyEnd span {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  margin: 0 20px;
}
.shopping .success .moneyEnd .moneyNumSuc {
  color: red;
  font-size: 28px;
}
.shopping .success .line {
  width: 75%;
  margin: 2% auto;
  height: 1px;
  background-color: #e8e8e8;
}
.shopping .success .oderDetailSuc {
  width: 42%;
  margin: 0 auto;
  font-size: 14px;
  margin-top: 1%;
  text-align: left;
}
.shopping .success .orderSort {
  width: 42%;
  margin: 1% auto;
  color: #ccc;
  font-size: 12px;
  text-align: left;
}
.shopping .success .receivePeo {
  width: 42%;
  margin: 1% auto;
  color: #158DD3;
  font-size: 14px;
  text-align: left;
}
.shopping .success .receiveAddress {
  width: 42%;
  margin: 1% auto;
  color: #158DD3;
  font-size: 14px;
  text-align: left;
}
.shopping .success .estabTime {
  width: 42%;
  margin: 1% auto;
  color: #ccc;
  font-size: 12px;
  text-align: left;
}
.shopping .success .payTime {
  width: 42%;
  margin: 1% auto;
  color: #ccc;
  font-size: 12px;
  text-align: left;
}
.shopping .success .nextDiv {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-size: 12px;
  color: #ccc;
  margin: 1% 0;
}
.shopping .success .nextDiv .go {
  cursor: pointer;
  color: #158DD3;
  margin-left: 20px;
}
.shopping .success .nextDiv .go:hover {
  font-weight: 600;
}

.shopping .typeList_title {
  font-size: 18px;
  margin-bottom: 10px;
  text-align: left;
}
.shopping .type_list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.shopping .type_list .type_one {
  font-size: 12px;
  padding: 5px 8px;
  background: #f2f2f2;
  color: #666;
  border-radius: 20px;
}
.shopping .type_list .type_one.active {
  background: #158DD3;
  color: #fff;
}
.sxDiv {
  width: 80%;
  /* height: 137px; */
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(191, 191, 191, 1);
  border-radius: 6px;
  margin-left: 46px;
  margin-bottom: 50px;
}
.sxDiv p {
  width: 100%;
  /* height: 18px; */
  text-align: left;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  height: 50px;
  line-height: 50px;
  margin-left: 23px;
}
.sxDiv .sxUl {
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  width: 96%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-left: 23px;
}
.sxDiv .sxUl li {
  width: 23%;
  /* background-color: pink; */
  margin-right: 20px;
  text-align: left;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.sxDiv .sxUl li .borderSpan {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #158DD3;
  line-height: 13px;
  text-align: center;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
  margin-right: 5px;
  font-size: 12px;
}
.sxDiv .sxUl li .lefSpan {
  display: inline-block;
  /* width: 46%; */
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-clamp: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  word-wrap: none;
  margin: 0 10px;
}
.sxDiv .sxUl li .rigSpan {
  display: inline-block;
  /* width: 50%; */
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(128, 128, 128, 1);
  line-clamp: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  word-wrap: none;
}
/* <div class="sxDiv">
            <p class="sxTitle">产品参数</p>
            <ul v-for="(item,index) in sxList" :key="index" class="sxUl">
              <li><span class="lefSpan">item.formatName</span><span class="rigSpan">item.formatContent</span></li>
            </ul>
          </div> */
.shopping .com_detail {
  line-height: 26px;
  text-align: left;
  text-indent: 2em;
  padding-left: 20px;
  font-size: 14px !important;
  padding-bottom: 30px;
}
.shopping .com_detail img {
  max-width: 50% !important;
}
.shopping .el-tabs__item {
  padding: 0 20px;
  height: 40px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 40px;
  display: inline-block;
  list-style: none;
  font-size: 20px;
  font-weight: 500;
  color: #303133;
  position: relative;
  font-weight: 600;
  /* font-family: newFont!important; */
  /* font-family: monospace; */
  /* font-family: Microsoft YaHei; */
  font-style: italic;
  font-family:"Microsoft YaHei",微软雅黑,"MicrosoftJhengHei",华文细黑,STHeiti,MingLiu 
}
.shopping .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 30px 23px;
  padding-top: 10px;
  padding-left: 10px;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}
.shopping .el-tabs__item {
  border-right: 0;
}
.detailImg .el-carousel {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.thingDetail .el-tabs__nav-wrap::after {
  background-color: transparent !important;
}
.thingDetail .el-tabs__header {
  width: 80% !important;
  border-bottom: 1px solid #ccc !important;
  padding-left: 32px;
}
.shopping .backDiv .el-icon-arrow-left:before {
  content: "\E6DE";
  margin-left: 32px;
}
.el-tabs__active-bar {
  height: 3px;
}
.shopping .realPhone {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-align: right;
  width: 70%;
}
.shopping .thingDetail .detailPart .rigDesc .carNumPart {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 40px;
  /* background-color: purple; */
  padding: 30px 0;
  width: 72%;
  /* padding: 0 20px; */
}
/* .shopping .addressDiv {
  width: 80%;
  margin: 0 auto;
  font-size: 12px;
  color: gray;
  padding: 32px 0;
  padding-top: 50px;
  background-color: #fff;
  margin-top: -30px;
} */
#noDataDiv {
  margin-top: 50px;
  margin-bottom: 10px;
}
.newDiv {
  /* background-color: pink; */
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 22px;
}
.addGetAddress {
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  text-align: center;
  color: #fff;
  background-color: #158DD3;
  cursor: pointer;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  border: 4px;
}
.spUl .el-input-number {
  width: 90%;
}
.thingDetailLeft {
  margin-top: 20px;
  width: 14%;
  /* position: absolute;
  top: 80px;
  left: 8%; */
  float: left;
  margin-left: 8%;
  z-index: 99;
  /* position: relative; */
}
.newbottomArrow,
.newtopArrow {
  font-size: 20px;
  width: 100%;
  text-align: center;
  padding: 5px 5px;
  background-color: #fff;
  cursor: pointer;
  color: #666;
  /* background-color: pink; */
  opacity: 1;
}
.newbottomArrow:hover,
.newtopArrow:hover{
  color: #158DD3;
}
/* #sortHort:hover .bottomArrow{
  opacity: 1!important;
} */
.thingDetailLeft .tellP {
  width: 100%;
  padding-left: 10px;
  padding-top: 10px;
  text-align: left;
  font-size: 15px;
  height: 20px;
  background-color: #fff;
  padding-bottom: 10px;
}
#sortHort {
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 10px 5px;
  background-color: #fff;
  overflow: scroll;
}
#sortHort::-webkit-scrollbar {
  display: none;
}
#sortHort li {
  width: 100%;
  /* height: 100px; */
  margin-bottom: 15px;
  cursor: pointer;
  /* background-color: pink; */
}
#sortHort li .hotTop {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  /* height: 300px; */
}
#sortHort li .hotTop .sortNum {
  width: 20px;
  height: 20px;
  line-height: 20px;
  /* background-color: #158DD3; */
  background-color: red;
  font-size: 14px;
  color: #fff;
  border-radius: 50%;
  margin-right: 10px;
}
#sortHort li .hotTop .hotImgDiv {
  width: 100%;
  /* background-color: green; */
}
#sortHort li .hotTop .hotImgDiv img {
  display: block;
  width: 100%;
  height: 100%;
}
#sortHort li .hotMoney {
  height: 20px;
  width: 100%;
  margin: 0 auto;
  line-height: 20px;
  font-size: 15px;
  color: red;
  /* padding: 10px 0; */
  text-align: left;
  background-color: #fff;
  margin-top: 10px;
}
#sortHort li .hotName {
  height: 34px;
  width: 100%;
  /* margin: 0 auto; */
  /* line-height: 5px; */
  font-size: 13px;
  color: #666;
  margin: 11px auto;
  text-align: left;
  /* background-color: yellow; */
  word-wrap: normal;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.shopping .top .lunbo .block .is-active img {
  max-width: 100% !important;
  max-height: 100% !important;
  /* margin: 0 auto; */
  position: relative !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
}
/* <div class="thingDetailLeft" v-if="isDetail==2">
      <p class="tellP">商品推荐</p>
      <ul id="sortHort">
        <li v-for="(items,ind) in hots" :key="ind" @click="seeDeatil(ind)" :style="{height:newLiH+'px'}">
          <div class="hotTop">
            <div class="sortNum">
              {{ind+1}}
            </div>
            <div hotImgDiv>
                <img :src="items.imgurl.split(',')[0]" alt="">
            </div>
          </div>
          <p class="hotMoney">{{items.money}}</p>
          <p class="hotName">{{items.name}}</p>
        </li>
      </ul>
    </div> */
.perBoss{
  width: 100%;
  position: relative;
}
.perUl{
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  overflow: scroll;
  background-color: pink;
}
.perUl::-webkit-scrollbar{
  display: none;
}
.perUl li{
  width: 180px;
  height: 200px;
}
.perUl li img{
  display: block;
  width: 100%;
  height: 100%;
}
.perArrowLeft,
.perArrowRight{
  position: absolute;
  left: 0;
  z-index: 9;
}
.perArrowRight{
  right: 0;
}
/* <div class="perBoss">
        <div class="el-icon-arrow-left perArrowLeft"></div>
        <ul class="perUl">
          <li v-for="(item,index) in hots" :key="index" :index="index" @click="seeDeatil(index)"></li>
        </ul>
        <div class="el-icon-arrow-right perArrowRight"></div>
</div> */
</style>



// WEBPACK FOOTER //
// src/components/shopping.vue